import { AddOnFilterKey, AddOnFilterModel } from '../domain';
import { useFilter } from '../../filter';

export const useAddOnFilter = () => {
  return useFilter(
    AddOnFilterKey,
    'addOnFilter',
    (filter: any) => new AddOnFilterModel(filter),
    true
  );
};
